var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.44762 0.877281C8.37571 0.861089 8.30087 0.852539 8.22402 0.852539C3.72073 0.852539 0.186279 4.70658 0.186279 9.3138C0.186279 13.921 3.72073 17.7751 8.22402 17.7751C8.25792 17.7751 8.29142 17.7734 8.32446 17.7701C7.40546 17.0825 6.60244 16.2496 5.95049 15.3053C3.77208 14.3503 2.19571 12.0626 2.19571 9.3138C2.19571 6.51842 3.82594 4.19988 6.06173 3.2749C6.72269 2.35416 7.52928 1.54407 8.44762 0.877281Z",
    fill: "#556171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.44762 0.877281C8.37571 0.861089 8.30087 0.852539 8.22402 0.852539C3.72073 0.852539 0.186279 4.70658 0.186279 9.3138C0.186279 13.921 3.72073 17.7751 8.22402 17.7751C8.25792 17.7751 8.29142 17.7734 8.32446 17.7701C7.40546 17.0825 6.60244 16.2496 5.95049 15.3053C3.77208 14.3503 2.19571 12.0626 2.19571 9.3138C2.19571 6.51842 3.82594 4.19988 6.06173 3.2749C6.72269 2.35416 7.52928 1.54407 8.44762 0.877281Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6987 15.8948C18.3363 15.8948 21.2852 12.9731 21.2852 9.3691C21.2852 5.76507 18.3363 2.84342 14.6987 2.84342C11.0611 2.84342 8.11222 5.76507 8.11222 9.3691C8.11222 12.9731 11.0611 15.8948 14.6987 15.8948ZM14.6987 17.8857C19.4461 17.8857 23.2946 14.0727 23.2946 9.3691C23.2946 4.66554 19.4461 0.852539 14.6987 0.852539C9.9513 0.852539 6.10278 4.66554 6.10278 9.3691C6.10278 14.0727 9.9513 17.8857 14.6987 17.8857Z",
    fill: "#556171"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6987 15.8948C18.3363 15.8948 21.2852 12.9731 21.2852 9.3691C21.2852 5.76507 18.3363 2.84342 14.6987 2.84342C11.0611 2.84342 8.11222 5.76507 8.11222 9.3691C8.11222 12.9731 11.0611 15.8948 14.6987 15.8948ZM14.6987 17.8857C19.4461 17.8857 23.2946 14.0727 23.2946 9.3691C23.2946 4.66554 19.4461 0.852539 14.6987 0.852539C9.9513 0.852539 6.10278 4.66554 6.10278 9.3691C6.10278 14.0727 9.9513 17.8857 14.6987 17.8857Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.29db7ddfb4d92781e2c7af9189500cc1.svg";
export { ForwardRef as ReactComponent };